import { PhoneCall } from "lucide-react";

export default function StickyMobileCTA() {
  return (
    <div
      className="fixed bottom-0 inset-x-0 z-40 md:hidden p-3 bg-[#0B0D10]/90 backdrop-blur-xl border-t border-white/10"
      data-testid="sticky-mobile-cta"
    >
      <a
        href="/#yhteys"
        className="md-btn-primary w-full justify-center text-base"
        data-track="mobile-cta"
      >
        <PhoneCall size={18} /> Varaa maksuton kartoitus
      </a>
    </div>
  );
}
